import { secondAxios } from "../../../../api/axios";
import { projectTypeDiscipline } from "../../../../constants/projectTypes";

/**
 * @param {string} pnidPath
 * @returns {unknown}
 */
export async function fetchExtractPnid(pnidPath) {
  const data = window.electron.piping.exportPnid(pnidPath);
  return data;
}

export async function fetchAllRevsForProject(projectId) {
  const res = await secondAxios.get(`/project/${projectId}/rev`);
  return res.data;
}

export async function fetchProjectRev(projectId, revId) {
  const res = await secondAxios.get(`/project/${projectId}/rev/${revId}`);
  return res.data;
}

export async function postProjectRev(projectId, data) {
  const res = await secondAxios.post(`/project/${projectId}/rev`, data);
  return res.data;
}
export async function updateProjectRev(projectId, revId, data) {
  const res = await secondAxios.patch(
    `/project/${projectId}/rev/${revId}`,
    data,
  );
  return res.data;
}
export async function postSpecRowFromUi(row) {
  const res = await window.electron.piping.getSpecRowFromUi({ row });
  // console.log("res in api", res);
  return res;
}
export async function postUnitWeightFromFamilyname(row) {
  const res = window.electron.piping.getUintWeightFromFamilyname(row);
  // console.log("res in api", res);
  return res;
}
export async function exportlineList(excelPath) {
  const res = window.electron.piping.exportlineList(excelPath);
  // console.log("res in api", res);
  return res;
}

export async function fetchInstrumentationRev(projectId, revId) {
  const res = await secondAxios.get(`/project/${projectId}/rev/${revId}`);
  // console.log("rev res:", res.data);
  return res.data;
}

export async function postInstrumentationRev(projectId, data) {
  const res = await secondAxios.post(`/project/${projectId}/rev`, data);
  return res.data;
}
export async function updateInstrumentationRev(projectId, revId, data) {
  console.log("Updating Instrumentation revision with data:", data);
  const res = await secondAxios.patch(
    `/project/${projectId}/rev/${revId}`,
    data,
  );
  return res.data;
}
// Every Instrumentation WBS in the plant - "INE" or its full "Estimation -
// Instrumentation" name. Filtered here rather than with the endpoint's ?type=,
// which matches one exact stored value and so would miss the other form.
export async function getInstrumentationPlantProjects(plantId, clientName) {
  const res = await secondAxios.get(`project/plant/${plantId}/${clientName}`);
  const list = Array.isArray(res.data)
    ? res.data
    : Array.isArray(res.data?.data)
      ? res.data.data
      : [];

  return list.filter(
    (project) => projectTypeDiscipline(project?.type) === "ins",
  );
}
export async function getProjectById(projectId) {
  const response = await secondAxios.get(
    `/project/${projectId}?revisions=true&users=true`,
  );
  // console.log("response", { response });
  if (typeof response.data?.data === "string") {
    return JSON.parse(response.data?.data);
  }
  return response?.data;
}

export async function getPlantById(plantId) {
  const res = await secondAxios.get(`/plant/${plantId}`);
  return res.data;
}
